import React from 'react';
import { Control, UseFormSetValue, UseFormWatch, FieldErrors, useFieldArray } from 'react-hook-form';
import { EducationFieldset } from '@/features/Collaborators/Edit/Form/Fieldsets';
import { CollaboratorFormData } from '@/features/Collaborators/Edit/Types';
import { CollaboratorFormContext } from "@/features/Collaborators/Edit/Contexts/CollaboratorFormContext";

interface EducationTabProps {
    context: CollaboratorFormContext;
    collaboratorId: string;
    control: Control<CollaboratorFormData>;
    setValue: UseFormSetValue<CollaboratorFormData>;
    watch: UseFormWatch<CollaboratorFormData>;
    errors: FieldErrors<CollaboratorFormData>;
    isSubmitting?: boolean;
}

const EducationTab: React.FC<EducationTabProps> = ({
    context,
    collaboratorId,
    control,
    setValue,
    watch,
    errors,
    isSubmitting = false
}) => {
    const { fields, append, remove } = useFieldArray({
        control,
        name: 'educations'
    });

    return (
        <div className="space-y-6">
            <EducationFieldset
                context={context}
                collaboratorId={collaboratorId}
                control={control}
                setValue={setValue}
                watch={watch}
                errors={errors}
                isSubmitting={isSubmitting}
                fields={fields}
                append={append}
                remove={remove}
            />
        </div>
    );
};

export default EducationTab;